import axios from 'axios'
import { toastr } from 'react-redux-toastr'

import { URL } from '../../assets/js/constants'

function pagamentosLoading(data) {
    return {
        type: 'PAGAMENTOS_LOADING',
        payload: data
    }
}

function pagamentosProcessing(data) {
    return {
        type: 'PAGAMENTOS_PROCESSING',
        payload: data
    }
}

export function carregarRepassesAoVendedor(data) {
    return {
        type: 'REPASSES_FETCHED',
        payload: data
    }
}

export function carregarRepasseAoVendedor(data) {
    return {
        type: 'REPASSE_FETCHED',
        payload: data
    }
}

export function getRepassesAoVendedor() {
    return dispatch => {
        dispatch(pagamentosLoading(true));
        axios.get(`${URL}/payment/v1/repasses`)
            .then(resp => {
                dispatch(carregarRepassesAoVendedor(resp.data));
                dispatch(pagamentosLoading(false));
            })
            .catch(e => {
                dispatch(pagamentosLoading(false));
                toastr.error('Erro', e.message);
            })
    }
}

export function getRepasseAoVendedor(id) {
    return dispatch => {
        dispatch(pagamentosLoading(true));
        axios.get(`${URL}/payment/v1/repasse/${id}`)
            .then(resp => {
                dispatch(carregarRepasseAoVendedor(resp.data));
                dispatch(pagamentosLoading(false));
            })
            .catch(e => {
                dispatch(pagamentosLoading(false));
                toastr.error('Erro', e.message);
            })
    }
}

export function autorizarRepasseAoVendedor(id) {
    return dispatch => {
        dispatch(pagamentosProcessing(true));
        axios.post(`${URL}/payment/v1/authorize-transfer/${id}`)
            .then(resp => {
                toastr.success('Sucesso', 'Repasse solicitado com sucesso.');
                dispatch(pagamentosProcessing(false));
            })
            .catch(e => {
                dispatch(pagamentosProcessing(false));
                toastr.error('Erro', e.message);
            })
    }
}

export function atualizarRepasse(data) {
    const id = data.id;
    return dispatch => {
        dispatch(pagamentosProcessing(true));
        axios.put(`${URL}/payment/v1/repasse/${id}`, data)
            .then(resp => {
                toastr.success('Sucesso', 'Repasse atualizado com sucesso.');
                dispatch(pagamentosProcessing(false));
            })
            .catch(e => {
                dispatch(pagamentosProcessing(false));
                toastr.error('Erro', e.message);
            })
    }
}